import TextAboveFooter from './views/TextAboveFooter.c';
export default TextAboveFooter;
